import { useRequestsHandlerData } from './useRequestsHandlerData'
import { loadImages } from '../utils/img/img'
import { useApplicationCallbacks } from '../providers/application-callbacks'
import { getIsAvailableEvent } from '../constants/events'
import { useModal } from './useModal'
import { defaultStore } from '../translations'
import { profileModalContent } from '../constants/copyright-modals'
import { useState } from 'react'

const { buttons } = profileModalContent

export const useExtraProfileFriend = () => {
  const { addModal, modals } = useModal()
  const isCanOpenModal = modals.every(({ type }) => type !== 'profileModal')
  const callbacks = useApplicationCallbacks()
  const [isProcessing, setIsProcessing] = useState(false)

  const isPending = useRequestsHandlerData([
    {
      address: 'requestsUserGetFriend',
      async fulfilled(data) {
        if (!isCanOpenModal) return

        setIsProcessing(true)

        try {
          const filteredButtons = buttons.filter(
            ({ event }) => !event || getIsAvailableEvent(defaultStore, event),
          )
          const {
            user: { uid, items },
          } = data

          callbacks.setIsVisible(false)

          await loadImages(items.reduce((acc, { image }) => (image ? [...acc, image] : acc), []))

          addModal({
            type: 'profileModal',
            props: {
              buttons: filteredButtons.map((button) => ({
                ...button,
                ...(button.hasOwnProperty('uid') && { callbackOptions: uid }),
              })),
            },
          })
        } finally {
          setIsProcessing(false)
        }
      },
    },
  ])

  return isPending || isProcessing
}
